import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { alignerMaterialSchema } from "../../schemas/alignerMaterialSchema";
import { addAlignerMaterial } from "../../../../api/alignerMaterialsApi";
const AddAlignerMaterialDialog = ({
  openAddAlignerMaterial,
  handleCloseAddAlignerMaterial,
  currentAlignerMaterial,
  fetchAlignerMaterials,
  handleOpenAlert,
  handleSetAlertMessage,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(alignerMaterialSchema),
    defaultValues: {
      name: "",
      serviceId: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.serviceId = currentAlignerMaterial.serviceId;
    reset({ ...defaultValues });
  }, [currentAlignerMaterial, reset]);

  const submitAddService = async (values) => {
    const response = await addAlignerMaterial(values);
    if (response.data.code != null) {
      handleSetAlertMessage(response.data.message);
      handleOpenAlert();
    } else {
      handleCloseAddAlignerMaterial();
      fetchAlignerMaterials();
    }
  };

  return (
    <div>
      <StyledDialog
        open={openAddAlignerMaterial}
        onClose={handleCloseAddAlignerMaterial}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Add Aligner Material</DialogTitle>
        <form onSubmit={handleSubmit(submitAddService)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Aligner Material"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddAlignerMaterial}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddAlignerMaterialDialog;
